module.exports = __webpack_public_path__ + "img/dataAire.c5ca5692.jpg";